import { ReactNode } from "react";
import styles from "./CommandIslandTotal.module.scss";

interface CommandIslandTotalProps {
    children: ReactNode;
}

export const CommandIslandTotal = ({ children }: CommandIslandTotalProps) => (
    <span className={styles.commandIslandTotal}>{children}</span>
);
